import React, { type JSX } from 'react';

// Deterministic pseudo-random heights that mimic a real audio waveform
const BAR_HEIGHTS = [
  8, 14, 10, 18, 22, 16, 12, 20, 24, 14,
  10, 18, 22, 8, 16, 24, 12, 20, 14, 10,
  18, 22, 16, 8, 20, 12, 24, 14,
];

function WaveMini ({
  progress = 0,
  animated = false,
}: {
  progress?: number;
  animated?: boolean;
}): JSX.Element {
  return (
    <div className="relative flex items-center gap-[2px]">
      {BAR_HEIGHTS.map((h, i) => {
        const done = i / BAR_HEIGHTS.length <= progress;
        return (
          <span
            key={i}
            className={`w-[3px] rounded-full ${done ? 'bg-sky-500' : 'bg-gray-400/60'} ${animated ? 'animate-pulse' : ''}`}
            style={{ height: `${h}px` }}
          />
        );
      })}
    </div>
  );
}

export default WaveMini;
